import type { WaitlistEntry } from '@vagusx/clients';
import { EhrSyncStatus } from '@/components/ehr/EhrSyncStatus';
import { waitlistEhrSyncState } from '@/lib/ehr-sync-state';

interface WaitlistEhrSyncStatusProps {
  entry: Pick<WaitlistEntry, 'ehr'>;
  /** The viewer pressed Send to EHR now and is watching it: a queued entry animates. */
  sending?: boolean;
  /** Re-sync beside a failed or retrying status; omit to show the status only. */
  onResync?: () => void;
  isResyncing?: boolean;
  className?: string;
}

/**
 * A waitlist entry's EHR sync status (ADR-285, ADR-292): synced, queued (static),
 * syncing (only while `sending`), retrying or failed with the error on hover,
 * and Re-sync beside a failure. Renders nothing for an entry that isn't sent to
 * an EHR.
 */
export function WaitlistEhrSyncStatus({
  entry,
  sending = false,
  onResync,
  isResyncing,
  className,
}: WaitlistEhrSyncStatusProps): React.ReactElement | null {
  const state = waitlistEhrSyncState(entry.ehr, { sending });
  if (!state) return null;
  return (
    <EhrSyncStatus
      state={state}
      onResync={onResync}
      isResyncing={isResyncing}
      className={className}
    />
  );
}
